module.exports = __webpack_public_path__ + "img/bi_footer.ce8c67ee.svg";